import { BrowserInstancesList } from '../components/BrowserInstancesList';

export function BrowserPoolPage() {
  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Browser Pool</h1><p className="text-sm text-neutral-500">Instances Puppeteer actives</p></div>
      <BrowserInstancesList />
    </div>
  );
}
